// extracted by mini-css-extract-plugin
export default {"wrapper":"WeUpgradeSummer_wrapper__5rotw","content":"WeUpgradeSummer_content__wFsc6","marginTop":"WeUpgradeSummer_marginTop__6vJug"};